import React from "react";
import { Card, CardBody, CardHeader } from "@material-tailwind/react";
import animationData from "../assets/images/Coming-Soon.json";
import Lottie from "lottie-react";
import { useAuthUserToken } from "../hooks/useAuthUserToken";

const ComingSoon = () => {
  const { refreshToken } = useAuthUserToken();
  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="p-12 mb-6 pt-6 rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible !m-0"
        >
          <div className="text-[24px] pb-4 font-black text-black">
            Welcome to{" "}
            <span className="text-transparent bg-gradient-to-r from-indigo-400 to-cyan-400 bg-clip-text relative">
              TrustSpike Audit Management Platform!
            </span>
          </div>
        </CardHeader>

        <CardBody className="!p-0">
          <div className="flex justify-center">
            <Lottie
              height={200}
              width={200}
              animationData={animationData}
              loop={true}
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default ComingSoon;
